var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10H5.55556H3.33333H1.94444H0L5 16L10 10L7.5 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89258 11.3001C4.89258 6.1094 9.00188 2.0001 14.1926 2.0001C19.3833 2.0001 23.4926 6.1094 23.4926 11.3001C23.4926 16.2745 19.5996 20.3838 14.6251 20.6001",
    fill: "none",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6256 20.6001C14.4094 20.6001 14.4094 20.6001 14.1931 20.6001C12.0303 20.6001 10.0838 19.9513 8.56982 18.6536",
    fill: "none",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

export default SvgRotate;